
var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
var spp = 0; var timerspp = setInterval(function(){
  if(jQuery('p.affirm-as-low-as').length) {
	 jQuery('.payment-buttons').eq(0).before(jQuery('p.affirm-as-low-as').eq(0))
clearInterval(timerspp);}if( spp > 200){clearInterval(timerspp);}spp++;}, 50);
  
jQuery('.payment-buttons').eq(0).after(jQuery(`<div class="saint-feature-list">
    <div class="saint-feature-item">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_3_35" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3_35)">
    <path d="M4 22V8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H20V22H4ZM6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z" fill="#1C1B1F"/>
  </g>
</svg>
        <span class="saint-feature-text">Secure Checkout</span>
    </div>
    <div class="saint-feature-item">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_3_38" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3_38)">
    <path d="M11 19.425V12.575L5 9.10001V15.95L11 19.425ZM13 19.425L19 15.95V9.10001L13 12.575V19.425ZM12 22.3L3 17.125V6.87501L12 1.70001L21 6.87501V17.125L12 22.3ZM16 8.52501L17.925 7.42501L12 4.00001L10.05 5.12501L16 8.52501ZM12 10.85L13.95 9.72501L8.025 6.30001L6.075 7.42501L12 10.85Z" fill="#1C1B1F"/>
  </g>
</svg>
        <span class="saint-feature-text">Free Shipping</span>
    </div>
    <div class="saint-feature-item">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_3_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3_41)">
    <path d="M9 21L7.575 19.6L9.175 18H9C7.05 18 5.39583 17.3208 4.0375 15.9625C2.67917 14.6042 2 12.95 2 11C2 9.05 2.67917 7.39583 4.0375 6.0375C5.39583 4.67917 7.05 4 9 4H15C16.95 4 18.6042 4.67917 19.9625 6.0375C21.3208 7.39583 22 9.05 22 11C22 12.95 21.3208 14.6042 19.9625 15.9625C18.6042 17.3208 16.95 18 15 18V16C16.3833 16 17.5625 15.5125 18.5375 14.5375C19.5125 13.5625 20 12.3833 20 11C20 9.61667 19.5125 8.4375 18.5375 7.4625C17.5625 6.4875 16.3833 6 15 6H9C7.61667 6 6.4375 6.4875 5.4625 7.4625C4.4875 8.4375 4 9.61667 4 11C4 12.3833 4.4875 13.5708 5.4625 14.5625C6.4375 15.5542 7.61667 16.1 9 16.2H9.4L7.6 14.4L9 13L13 17L9 21Z" fill="#1C1B1F"/>
  </g>
</svg>
        <span class="saint-feature-text">Return Policy</span>
    </div>
    <div class="saint-feature-item">
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_3_44" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3_44)">
    <path d="M16.7 14.5L20.5 11.25L23.5 11.5L19.1 15.325L20.4 21L17.85 19.45L16.7 14.5ZM14.35 7.2L13.3 4.75L14.45 2L16.75 7.425L14.35 7.2ZM7.35 16.825L10.5 14.925L13.65 16.85L12.825 13.25L15.6 10.85L11.95 10.525L10.5 7.125L9.05 10.5L5.4 10.825L8.175 13.25L7.35 16.825ZM4.325 21L5.95 13.975L0.5 9.25L7.7 8.625L10.5 2L13.3 8.625L20.5 9.25L15.05 13.975L16.675 21L10.5 17.275L4.325 21Z" fill="#1C1B1F"/>
  </g>
</svg>
        <span class="saint-feature-text">Warranty and Guarantee</span>
    </div>
</div>
`))



   
}); 
}


var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
   setTimeout(function(){ 
  const $shadowHost = $('envolve-vsa');
if ($shadowHost[0].shadowRoot) {
  const $style = $('<style>').text(`
   div#envolve-launcher{
      bottom: 100px!important;
      right: 75px;
    }
    @media screen and (max-width: 768px) {
 div#envolve-launcher{
      bottom: 130px!important;
      right: 75px;
    }
}
  `);
  $($shadowHost[0].shadowRoot).append($style);
}
}, 3000);
  
  var btnClass = "button.btn.btn--full.add-to-cart.btn--secondary";
  var prodTitle = ".product-single__title";
  var prodPrice = ".product-block.product-block--price";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p><div class="st-reviews"></div></div></div> <div class="simple-st-container__inner"><div class="simple-st-item_column__button"><div class="simple-product-price"></div><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);

  var rr = 0; var timerrr = setInterval(function(){
  if(jQuery('.jdgm-prev-badge').length) {
     setTimeout(function(){ 
	jQuery('.st-reviews').append(jQuery('.product-single__meta .jdgm-prev-badge').eq(0).clone())

       $('.st-reviews span.jdgm-prev-badge__text').click(function(){
 jQuery('.product-single__meta span.jdgm-prev-badge__text').eq(0).click()
}); 
}, 1000);

clearInterval(timerrr);}if( rr > 200){clearInterval(timerrr);}rr++;}, 50);
  
jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());

setTimeout(function(){ 
jQuery('.simple-product-price').eq(0).html(jQuery(prodPrice).html());
}, 1000);
  
 

  
  jQuery('.simple-st-item__button').click(function(){
    window.scrollTo({
        top: document.querySelectorAll(prodTitle)[0].offsetTop,
        behavior: 'smooth'
    });
    
   
  });
  
 
    
};

       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('button.btn.btn--full.add-to-cart.btn--secondary:not([disabled])').eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}

